export const filteringTableGetButtonToolTipText = (
  nominationStatusTypeId,
  candidate = '',
) => (nominationStatusTypeId === 1 ? `Edit ${candidate}` : `View ${candidate}`);
